<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50.185"
    height="50.187"
    viewBox="0 0 50.185 50.187"
    style="fill: currentColor;"
  >
    <g
      id="Group_26921"
      data-name="Group 26921"
      transform="translate(-241.166 -226.657)"
    >
      <g
        id="Group_26920"
        data-name="Group 26920"
        transform="translate(15.819 -956.382)"
      >
        <circle
          id="Ellipse_80760"
          data-name="Ellipse 80760"
          cx="2.432"
          cy="2.432"
          r="2.432"
          transform="translate(242.904 1193.471)"
          opacity="0.8"
        />
        <circle
          id="Ellipse_80761"
          data-name="Ellipse 80761"
          cx="2.432"
          cy="2.432"
          r="2.432"
          transform="translate(242.904 1200.785)"
        />
        <circle
          id="Ellipse_80762"
          data-name="Ellipse 80762"
          cx="2.432"
          cy="2.432"
          r="2.432"
          transform="translate(242.904 1208.1)"
          opacity="0.8"
        />
        <circle
          id="Ellipse_80763"
          data-name="Ellipse 80763"
          cx="2.432"
          cy="2.432"
          r="2.432"
          transform="translate(250.219 1200.785)"
          opacity="0.8"
        />
        <circle
          id="Ellipse_80764"
          data-name="Ellipse 80764"
          cx="2.432"
          cy="2.432"
          r="2.432"
          transform="translate(235.59 1200.785)"
          opacity="0.8"
        />
      </g>
      <path
        id="ios-search-strong"
        d="M41.159,35.082a19.827,19.827,0,1,0-5.972,6.039l.9-.626L50.28,54.686,54.685,50.2,40.5,36.009Zm-5.632-21.8a15.714,15.714,0,1,1-11.109-4.6,15.612,15.612,0,0,1,11.109,4.6Z"
        transform="translate(236.666 222.158)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "pulse"
};
</script>
